export const TwitchIconSmall = () => {
    return (
        <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 21.5924C16.799 21.5924 21.5 16.8914 21.5 11.0924C21.5 5.29342 16.799 0.592407 11 0.592407C5.20101 0.592407 0.5 5.29342 0.5 11.0924C0.5 16.8914 5.20101 21.5924 11 21.5924Z"
                fill="#2E2E2E"
                stroke="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.95409 6.03357L6.17651 8.0123V16.1002H8.94098V17.563H10.4961L11.965 16.1002H14.2114L17.2353 13.0886V6.03357L6.95409 6.03357ZM16.1982 12.5727L14.4704 14.2934H11.7059L10.2371 15.7562V14.2934H7.90436V7.06593H16.1982V12.5727ZM14.4704 9.04515V12.0534H13.4338V9.04515H14.4704ZM11.7059 9.04515V12.0534H10.6693V9.04515H11.7059Z"
                fill="white"
            />
        </svg>
    );
};
